import { useRouter } from 'next/router'

function AuctionCategories({ auction }) {
    const router = useRouter()
    const { categories = [] } = auction

    const handleCategoryClick = ({category_id}) => {
        window.localStorage.setItem('search_obj',
            JSON.stringify({ filter_categories: category_id })
        )
        router.push(`/auctions`)
    }

    if (categories && categories.length > 0) {
        return (
            <div id="auction-details-category" className="col-md-12 marginT30 text-center marginB30">
                <div><strong>Auction Categories:</strong></div>
                <div className="marginT15">
                {categories.map((category, i) => (
                    <button
                        id={`auction-details-category-${category.slug}`}
                        onClick={() => handleCategoryClick(category)}
                        className="auction-category-boxes"
                        key={`auction-category-${i}`}
                    >
                    {category.category_name}
                    </button>
                        ))}
                </div>
            </div>
        )
    }

    return (
        <div className="col-md-12 marginT15 marginB15" />
    )
}

export default AuctionCategories
